__turbopack_context__.v({
  "is_gap": "Title-module-scss-module__p-d_uW__is_gap",
  "title": "Title-module-scss-module__p-d_uW__title",
  "title_center": "Title-module-scss-module__p-d_uW__title_center",
  "title_group": "Title-module-scss-module__p-d_uW__title_group",
  "title_group_center": "Title-module-scss-module__p-d_uW__title_group_center",
  "title_group_left": "Title-module-scss-module__p-d_uW__title_group_left",
  "title_group_mo_center": "Title-module-scss-module__p-d_uW__title_group_mo_center",
  "title_group_mo_left": "Title-module-scss-module__p-d_uW__title_group_mo_left",
  "title_group_mo_right": "Title-module-scss-module__p-d_uW__title_group_mo_right",
  "title_group_right": "Title-module-scss-module__p-d_uW__title_group_right",
  "title_left": "Title-module-scss-module__p-d_uW__title_left",
  "title_mo_center": "Title-module-scss-module__p-d_uW__title_mo_center",
  "title_mo_left": "Title-module-scss-module__p-d_uW__title_mo_left",
  "title_mo_right": "Title-module-scss-module__p-d_uW__title_mo_right",
  "title_right": "Title-module-scss-module__p-d_uW__title_right",
});
